import type { RouteRecordRaw } from 'vue-router'

export const marketCountriesRoutes: RouteRecordRaw[] = [
  {
    path: '/masters/market-countries',
    name: 'MARKET_COUNTRIES',
    component: () => import('./MarketCountriesPage.vue'),
    meta: { requiresAuth: true, permission: 'super_admin' },
  },
]
